

import React, { memo, useCallback } from 'react';

import SVG from 'react-inlinesvg';
import globalConfig from 'react-global-configuration';
import { Button, Text } from '../../../ui-kit';
import { empty } from '../../../ui-kit/assets/images';
import HelpCenterButton from '../../../common/components/HelpCenterButton';
import { redirectToSingleLogout, getSSOLocalStore, clearSSOLocalStore } from '../../AppSwitcherHeader/utils';
import '../styles/_not-found.scss';








function goHome(homeUrl, history) {
  if (homeUrl) {return () => {window.location.assign(homeUrl);};}

  return () => {history.push('/');};
}

function NotFound({
  homeUrl,
  history,
  heading = 'There\'s nothing here',
  subtitle = 'This particular page doesn\'t seem to exist. The link you clicked may be broken or the page may have been removed. Try reloading the page, or if the problem persists, reset your session and reopen the app.'
}) {
  const handleResetAndReopen = useCallback(() => {
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear SSO local store
    clearSSOLocalStore();

    // Check if SSO is enabled
    const { ssoEnabled } = getSSOLocalStore();

    // Redirect to appropriate logout endpoint
    if (ssoEnabled) {
      // SSO enabled: redirect to SSO logout
      redirectToSingleLogout();
    } else {
      // SSO not enabled: redirect to identity logout endpoint
      // This clears all credentials (client-side AND server-side) in identity
      // and automatically redirects back to the login flow
      const identityEndpoint = globalConfig.get('identityEndpoint');
      const { origin } = new URL(identityEndpoint);
      window.location.href = `${origin}/logout`;
    }
  }, []);

  return (
    <div className="not-found">
      <div className="not-found__inner">
        <div className="not-found__artwork">
          <SVG
            src={empty}
            title="Not Found"
            preProcessor={(code) => code.replace(/width="[^"]*"/, '').replace(/height="[^"]*"/, '')} />

        </div>
        <div className="not-found__content">
          <Text className="not-found__header" noMargin="top" heading2>
            {heading}
          </Text>
          <Text className="not-found__subtitle" subtitle noMargin="bottom">
            {subtitle}
          </Text>
          <div className="not-found__buttons">
            <Button onClick={goHome(homeUrl, history)} primary>Go Home</Button>
            <Button onClick={handleResetAndReopen} secondary>Reset and Reopen App</Button>
          </div>
        </div>
      </div>
      <div className="not-found__assist">
        <Text noMargin="bottom">
          If you keep running into this problem,
          try contacting your Account Manager or visit our
          <strong><HelpCenterButton /></strong>
          for more information.
        </Text>
      </div>
    </div>);

}

export default memo(NotFound);